import { AxiosResponse } from "axios";
import { invalidateWelcomeDashboardAccess } from "./welcomeDashboardAccessPolicy";
import { QueryClient, useMutation, useQuery, useQueryClient } from "react-query";
import { IPermission } from "../../compiler/global.interface";
import { IResetPasswordFormValues } from "../../components/global/Modal/ResetPasswordModal";
import { IUserAccessManageProps } from "../../components/pages/Setting/Access/User/UserAccessManage";
import { IUserInformationFormValues } from "../../components/pages/Setting/Access/User/UserInformation";
import { IMemberGroupFieldValue, IUserMemberManageFormValues } from "../../components/pages/Setting/Access/User/UserMemberManage";
import { APICreateUser, APIGetAllUsers, APIGetUserGroupByUUID, APIGetUserPermissionByUUID, APIUpdateUserByUUID, APIUpdateUserGroupByUUID, APIUpdateUserPasswordByUUID, APIUpdateUserPermissionByUUID } from "../../service/api/APIUserCRUD";

export enum EQueryUserCRUD {
    GetAllUsers = 'GetAllUsers',
    GetUserGroupByUUID = 'GetUserGroupByUUID',
    GetUserPermissionByUUID = 'GetUserPermissionByUUID',
    CreateUser = 'CreateUser',
    EditUserByUUID= 'EditUserByUUID',
    EditUserGroupByUUID = 'EditUserGroupByUUID',
    EditUserPermissionByUUID = 'EditUserPermissionByUUID',
    EditUserPasswordByUUID = 'EditUserPasswordByUUID'
}

export interface IUseGetUserCRUDProps{

}

export const useGetAllUsers= () => {
    return useQuery(EQueryUserCRUD.GetAllUsers,() => APIGetAllUsers())
}

export const useGetUserGroupByUUID = (uuid) => {
    return useQuery(EQueryUserCRUD.GetUserGroupByUUID,() => APIGetUserGroupByUUID(uuid),{
        enabled:!!uuid
    })
}

export const useGetUserPermissionByUUID = (uuid) => {
    return useQuery([EQueryUserCRUD.GetUserPermissionByUUID, uuid], () => APIGetUserPermissionByUUID(uuid), {
        enabled: !!uuid
    })
}

export const useCreateUser = () => {
    const queryClient = useQueryClient()

    return useMutation(EQueryUserCRUD.CreateUser,(payload:IUserInformationFormValues) => APICreateUser(payload),{
        onSuccess:()=>{
            queryClient.invalidateQueries(EQueryUserCRUD.GetAllUsers)
            void invalidateWelcomeDashboardAccess(queryClient)
        }
    })
}

export const useEditUserByUUID = (uuid:string | null) => {
    const queryClient = useQueryClient()
    
    return useMutation(EQueryUserCRUD.EditUserByUUID,(payload:IUserInformationFormValues)=>APIUpdateUserByUUID(uuid,payload),{
        onSuccess:()=>{
            queryClient.invalidateQueries(EQueryUserCRUD.GetAllUsers)
            void invalidateWelcomeDashboardAccess(queryClient)
        }
    })
}


export const useEditUserGroupByUUID = (uuid:string | null) => {
    const queryClient = useQueryClient()

    return useMutation(EQueryUserCRUD.EditUserGroupByUUID,(payload:IMemberGroupFieldValue[])=>APIUpdateUserGroupByUUID(uuid,payload), {
        onSuccess: () => {
            queryClient.invalidateQueries(['GetMemberGroupByUUID', uuid])
            void invalidateWelcomeDashboardAccess(queryClient)
        }
    })
}

export const useEditUserPermissionByUUID = (uuid:string | null) => {
    const queryClient = useQueryClient()
    
    return useMutation(EQueryUserCRUD.EditUserPermissionByUUID,(payload:IPermission[])=>APIUpdateUserPermissionByUUID(uuid,payload), {
        onSuccess: () => {
            queryClient.invalidateQueries([EQueryUserCRUD.GetUserPermissionByUUID, uuid])
            void invalidateWelcomeDashboardAccess(queryClient)
        }
    })
}

export const useEditUserPasswordByUUID = (uuid:string | null) => {
    const queryClient = useQueryClient()
    
    return useMutation(EQueryUserCRUD.EditUserPasswordByUUID,(payload:IResetPasswordFormValues)=>APIUpdateUserPasswordByUUID(uuid,payload))
}

// export const useDeleteUserCRUD = () => {
//     const queryClient = useQueryClient()
    
//     return useMutation<AxiosResponse,Error,IUseGetUserCRUDProps>(EQuery[Doamin].GetUserCRUD, [API]})
// }
